import { render, staticRenderFns } from "./OrderActionRelease.vue?vue&type=template&id=04416728&"
import script from "./OrderActionRelease.vue?vue&type=script&lang=ts&"
export * from "./OrderActionRelease.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports